module.exports = __webpack_public_path__ + "assets/img/partner1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner1.png
// module id = 1966
// module chunks = 0